import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.scss'],
  animations: [
    trigger('dialogAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.8)' }),
        animate('400ms ease-out', style({ opacity: 1, transform: 'scale(1)' })),
      ])
    ]),
  ],
})
export class ConfirmationPopupComponent {

  warningMsg: any = '';
  firstButton: any = '';
  secondButton: any = '';
  constructor(
    readonly dialogRef: MatDialogRef<ConfirmationPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.warningMsg = data.msg
    this.firstButton = data.firstButton
    this.secondButton = data.secondButton
  }

  ngOnInit(): void {

  }

  closePopup(response: any) {
    this.dialogRef.close(response);
  }

}
